import { addressStore } from '@/stores';
import { AddressType } from '@/types/enums';

export const getFormFields = () => [
  {
    name: 'factoryId',
    componentName: 'dropdown',
    params: {
      i18nLabel: 'waybills.factory',
      options: addressStore.items
        .filter((address) => address.type === AddressType.Factory)
        .map((item) => ({ value: item.id, label: item.name })),
    },
    rules: [{ required: true }],
  },
];
